import React, { useEffect, useState } from "react";
import { Flex, Icon, Stack, Text } from "@storyofams/react-ui";
import { createClient } from "@supabase/supabase-js";
import { useQuery } from "react-query";
import { useShopify } from "~context";
import { showToast } from "~lib";
import { Divider } from "~components/common/Divider";
import { Question, Star } from "~components/common/Icons";

export const Rating = ({ id, recipe, setRating, frame = false }) => {
  const { customer } = useShopify();
  const [hover, setHover] = useState<number>(0);

  const supabase = createClient(
    process.env.NEXT_PUBLIC_SUPABASE_URL,
    process.env.NEXT_PUBLIC_SUPABASE_KEY
  );
  const getRating = async (): Promise<any> => {
    try {
      //@ts-ignore
      let query = supabase
        .from("recipes_reviews")
        .select("email, rating")
        .eq("recipe_id", id);
      const { data } = await query;
      return data;
    } catch (err) {
      console.log(err);
    }
  };
  const { data: reviews, refetch } = useQuery("getRating", getRating, {
    enabled: Boolean(id),
  });
  const rating = reviews
    ? reviews.reduce((acc, { rating }) => acc + rating, 0) / reviews.length
    : 0;

  const isRated: number = reviews
    ? reviews.filter(
        (item) => item.email === customer?.emailAddress?.emailAddress
      ).length
    : 0;

  const sendRating = async (index) => {
    if (!customer) {
      showToast(
        "U moet geregistreerd zijn om een beoordeling achter te laten",
        "info"
      );
      return;
    }
    if (isRated) return;
    try {
      await supabase.from("recipes_reviews").insert([
        {
          email: customer?.emailAddress?.emailAddress,
          rating: index,
          recipe_id: id,
        },
      ]);
      refetch();
    } catch {
      showToast("Something wrong", "error");
    }
  };
  const goToSection = () => {
    const el = document?.getElementById("reviews");
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    }
  };

  useEffect(() => {
    setRating({ rating, reviews });
  }, [rating, reviews]);

  useEffect(() => {
    refetch();
  }, [recipe]);

  return (
    <Flex mb={["20px", 3]} mt={["10px", 1]}>
      {!!reviews?.length && (
        <Text
          fontWeight={600}
          lineHeight="22.4px"
          mr={1}
          fontSize={"16px"}
          pt="1px"
        >
          {reviews.length}
        </Text>
      )}
      <Stack space={0.25} mr={!isNaN(rating) && 1} position="relative">
        {[1, 2, 3, 4, 5].map((i) => (
          <Icon
            key={`star-${i}`}
            icon={Star}
            mr={"1px"}
            fontSize={"18px"}
            opacity={i <= (hover || rating) ? "1" : "0.5"}
            color={"oldPink"}
            onMouseEnter={() => {
              if (isRated) return;
              setHover(i);
            }}
            onMouseLeave={() => setHover(rating)}
            onClick={() => {
              sendRating(i);
            }}
          />
        ))}
      </Stack>
      {!isNaN(rating) && (
        <Text
          fontWeight={600}
          lineHeight="19.6px"
          mr={!customer && "5px"}
          fontSize={"16px"}
          pt="1px"
        >
          {rating.toFixed(1)}
        </Text>
      )}
      {frame && (
        <>
          <Divider mx="17px" vertical></Divider>
          <Flex
            cursor="pointer"
            onClick={(e) => {
              e.preventDefault();
              goToSection();
            }}
          >
            <Icon icon={Question} color="#767473" fontSize={"17px"} mr={1} />
            <Text fontSize={2} lineHeight={"19px"} color="#767473">
              Opmerkingen
            </Text>
          </Flex>
        </>
      )}
    </Flex>
  );
};
